import { createSlice } from '@reduxjs/toolkit';
import { OvertimePayState } from './overtimePayTypes';
import { 
  createOvertimePay, 
  fetchOvertimePays, 
  fetchOvertimePayById, 
  updateOvertimePay, 
  deleteOvertimePay 
} from './overtimePayActions';

const initialState: OvertimePayState = {
  overtimePays: [],
  selectedOvertimePay: undefined,
  loading: false,
  error: undefined,
};

const overtimePaySlice = createSlice({
  name: 'overtimePay',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create Overtime Pay
      .addCase(createOvertimePay.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(createOvertimePay.fulfilled, (state, action) => {
        state.loading = false;
        state.overtimePays.push(action.payload);
      })
      .addCase(createOvertimePay.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch All Overtime Pays
      .addCase(fetchOvertimePays.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchOvertimePays.fulfilled, (state, action) => {
        state.loading = false;
        state.overtimePays = action.payload.data;
      })
      .addCase(fetchOvertimePays.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch Overtime Pay by ID
      .addCase(fetchOvertimePayById.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchOvertimePayById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedOvertimePay = action.payload;
      })
      .addCase(fetchOvertimePayById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Overtime Pay
      .addCase(updateOvertimePay.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(updateOvertimePay.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.overtimePays.findIndex(pay => pay.id === action.payload.id);
        if (index !== -1) {
          state.overtimePays[index] = action.payload;
        }
      })
      .addCase(updateOvertimePay.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Delete Overtime Pay
      .addCase(deleteOvertimePay.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(deleteOvertimePay.fulfilled, (state, action) => {
        state.loading = false;
        state.overtimePays = state.overtimePays.filter(pay => pay.id !== action.payload.id);
      })
      .addCase(deleteOvertimePay.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default overtimePaySlice.reducer;
